"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = require("gsap");
const Cache_1 = require("../Cache");
const EventDispatcher_1 = __importDefault(require("../EventDispatcher"));
const Util_1 = __importDefault(require("../Util"));
const OrbitControls_1 = require("three/examples/jsm/controls/OrbitControls");
const stats_module_1 = __importDefault(require("three/examples/jsm/libs/stats.module"));
const Grid_1 = __importDefault(require("./Grid"));
const EventManager_1 = __importDefault(require("./EventManager"));
class Stage extends EventDispatcher_1.default {
    constructor({ container, production = true }) {
        var _a;
        super();
        this.stats = null;
        this.cache = Cache_1.cache;
        this.prod = production;
        this.size = { width: window.innerWidth, height: window.innerHeight };
        this.scene = new THREE.Scene();
        this.renderer = new THREE.WebGLRenderer({ antialias: false, alpha: true });
        this.camera;
        this.controls;
        this.frustumSize = 2;
        this.orthoCamera;
        this.activeCamera;
        this.isFixedCamera = false;
        this.mouse = new THREE.Vector2();
        this.mouse2d = new THREE.Vector2();
        this.cameraRange = 0.03;
        this.cameraBasePos = new THREE.Vector3();
        this.cameraTarget = new THREE.Vector3();
        this.events = new EventManager_1.default();
        if (container)
            this._init(container);
        this.grid = new Grid_1.default();
        this.add(this.grid);
        this._addEvent();
        this.update();
        if (!this.prod) {
            (_a = this.grid) === null || _a === void 0 ? void 0 : _a.show();
            this.controls.enabled = true;
            this.stats = stats_module_1.default();
            this.stats.dom.style.cssText =
                'position:fixed;bottom:0;left:0;cursor:pointer;opacity:0.9;z-index:10000;';
            if (container)
                container.appendChild(this.stats.dom);
        }
    }
    render() {
        if (this.renderer)
            this.renderer.render(this.scene, this.activeCamera);
    }
    add(obj) {
        this.scene.add(obj);
    }
    remove(obj) {
        this.scene.remove(obj);
    }
    update() {
        if (this.stats) {
            this.stats.update();
        }
        if (this.prod)
            this._updateCameraPos();
        this.render();
    }
    fixCamera() {
        this.isFixedCamera = true;
    }
    unFixCamera() {
        this.isFixedCamera = false;
    }
    _updateCameraPos() {
        if (this.isFixedCamera)
            return;
        const pos = this.camera.position;
        pos.x = pos.x + 0.2 * (this.cameraTarget.x - pos.x);
        pos.y = pos.y + 0.2 * (this.cameraTarget.y - pos.y);
    }
    _init(container) {
        this.scene.fog = new THREE.Fog(0x000000, 0, 100);
        this.renderer.setClearColor(0x000000, 1);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setPixelRatio(window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio);
        this.camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.01, 10000);
        this.camera.position.set(0, 0, 2);
        this.controls = new OrbitControls_1.OrbitControls(this.camera, this.renderer.domElement);
        this.controls.enabled = false;
        const aspect = this.size.width / this.size.height;
        this.frustumSize = 2;
        this.orthoCamera = new THREE.OrthographicCamera((this.frustumSize * aspect) / -2, (this.frustumSize * aspect) / 2, this.frustumSize / 2, this.frustumSize / -2, 0, 100);
        this.activeCamera = this.camera;
        container.appendChild(this.renderer.domElement);
        this.setMousePosition(this.size.width / 2, this.size.height / 2);
        if (this.prod) {
            this.controls.enabled = false;
        }
    }
    setMousePosition(x, y) {
        this.mouse.set((x / this.size.width) * 2 - 1, -(y / this.size.height) * 2 + 1);
        this.mouse2d.set(x, y);
    }
    fixCameraBasePos() {
        this.cameraBasePos.copy(this.camera.position);
        this.setCameraTarget(this.cameraBasePos);
    }
    setCameraTarget(basePos) {
        this.cameraTarget.x = Util_1.default.map(this.mouse2d.x, 0, this.size.width, basePos.x - this.cameraRange, basePos.x + this.cameraRange);
        this.cameraTarget.y = Util_1.default.map(this.mouse2d.y, 0, this.size.height, basePos.y + this.cameraRange, basePos.y - this.cameraRange);
    }
    _addEvent() {
        if (!this.renderer)
            return;
        if (this.renderer.domElement)
            this.events.init(this.renderer.domElement);
        this.events.addEventListener('resize', this._resize.bind(this));
        this.events.addEventListener('orientationchange', this._onOrientationChange.bind(this));
        this.events.addEventListener('mousemove', this._onMouseMove.bind(this));
        this.events.addEventListener('click', this._onClick.bind(this));
        this.events.addEventListener('touchstart', this._onTouchStart.bind(this));
        this.events.addEventListener('touchend', this._onTouchEnd.bind(this));
        this.events.addEventListener('touchmove', this._onTouchMove.bind(this));
    }
    _resize() {
        this.size.width = window.innerWidth;
        this.size.height = window.innerHeight;
        const aspect = this.size.width / this.size.height;
        if (this.activeCamera === this.orthoCamera) {
            this.orthoCamera.left = (-this.frustumSize * aspect) / 2;
            this.orthoCamera.right = (this.frustumSize * aspect) / 2;
            this.orthoCamera.top = this.frustumSize / 2;
            this.orthoCamera.bottom = -this.frustumSize / 2;
            this.orthoCamera.updateProjectionMatrix();
        }
        else {
            this.camera.aspect = aspect;
            this.camera.updateProjectionMatrix();
        }
        this.renderer.setSize(this.size.width, this.size.height);
    }
    _onOrientationChange() {
        this._resize();
        gsap_1.gsap.delayedCall(0.1, () => {
            this._resize();
        });
    }
    _onMouseMove(e) {
        if (e.originEvent instanceof MouseEvent)
            this.setMousePosition(e.originEvent.clientX, e.originEvent.clientY);
        this.setCameraTarget(this.cameraBasePos);
    }
    _onClick(e) {
        if (e.originEvent instanceof MouseEvent)
            this.setMousePosition(e.originEvent.clientX, e.originEvent.clientY);
    }
    _onTouchStart(e) {
        if (e.originEvent instanceof TouchEvent) {
            this.setMousePosition(e.originEvent.touches[0].pageX, e.originEvent.touches[0].pageY);
        }
    }
    _onTouchMove(e) {
        if (e.originEvent instanceof TouchEvent) {
            this.setMousePosition(e.originEvent.touches[0].pageX, e.originEvent.touches[0].pageY);
            this.setCameraTarget(this.cameraBasePos);
        }
    }
    _onTouchEnd() {
    }
    changeCamera() {
        this.activeCamera =
            this.activeCamera === this.camera ? this.orthoCamera : this.camera;
        this.controls.enabled = this.activeCamera === this.camera;
    }
}
exports.default = Stage;
